const features = [
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    desc: '无需翻页，手指下滑即可连续阅读，沉浸式体验让追漫更畅快。',
    color: 'primary',
  },
  {
    icon: 'ri-global-line',
    title: '韩日国漫全覆盖',
    desc: '韩漫、日漫、国漫三大品类一网打尽，满足各种口味偏好的漫画爱好者。',
    color: 'accent',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日稳定更新',
    desc: '热门连载作品保持与源头同步更新，日更100+话让读者每天都有新内容看。',
    color: 'primary',
  },
  {
    icon: 'ri-shield-check-line',
    title: '完全免费阅读',
    desc: '无需注册登录，无需付费充值，虫虫漫画所有内容永久免费开放。',
    color: 'accent',
  },
  {
    icon: 'ri-device-line',
    title: '多端完美适配',
    desc: '手机、平板、电脑全端自动适配，打开浏览器就能看，无需安装任何软件。',
    color: 'primary',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
            平台特色
          </h2>
          <p className="text-sm text-foreground-500">为什么数百万读者选择虫虫漫画看漫画</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.slice(0, 3).map((feature, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer group"
            >
              <div
                className={`w-11 h-11 rounded-xl flex items-center justify-center mb-4 ${
                  feature.color === 'primary' ? 'bg-primary-100 text-primary-600' : 'bg-accent-100 text-accent-600'
                }`}
              >
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {features.slice(3).map((feature, i) => (
            <div
              key={i + 3}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer group"
            >
              <div
                className={`w-11 h-11 rounded-xl flex items-center justify-center mb-4 ${
                  feature.color === 'primary' ? 'bg-primary-100 text-primary-600' : 'bg-accent-100 text-accent-600'
                }`}
              >
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}